import { clsx } from "clsx";
import type { SVGIconProps } from "../interface";
const iconSize: Record<string, string> = {
  8: "h-2",
  12: "h-3",
  16: "h-4",
  24: "h-6",
  32: "h-8",
  40: "h-10",
  48: "h-12",
  56: "h-14",
  80: "h-20",
  124: "h-30",
};
const SvgHeart = ({ title, titleId, size = 16, className }: SVGIconProps) => {
  const sizeClass = iconSize[size];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 17"
      width={size}
      height={size}
      className={clsx(sizeClass, className)}
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path d="M14.028.25a5.69 5.69 0 0 1 3.85 1.5l.205.198.003.003a5.875 5.875 0 0 1 0 8.194l-.003.003-5.392 5.475a3.776 3.776 0 0 1-5.381 0l-5.393-5.475-.003-.003a5.874 5.874 0 0 1 0-8.194l.003-.003A5.69 5.69 0 0 1 10 1.923 5.688 5.688 0 0 1 14.028.25m0 1.5c-1.122 0-2.197.45-2.984 1.25l-.51.518a.75.75 0 0 1-1.068 0L8.956 3a4.188 4.188 0 0 0-5.97 0 4.375 4.375 0 0 0 0 6.096L8.38 14.57l.168.154a2.274 2.274 0 0 0 3.074-.154l5.393-5.475a4.375 4.375 0 0 0 0-6.096 4.19 4.19 0 0 0-2.986-1.25" />
    </svg>
  );
};
export default SvgHeart;
